'use strict';

/**
 * The prefix of redis key-value (or userTokens) for verification link
 * @type {string}
 */
module.exports.VERIFICATION_LINK_KEY_PREFIX = "verificationLink";

/**
 * The ttl of redis key-value (or userTokens) for verification link
 * @type {number}
 */
module.exports.VERIFICATION_LINK_DEFAULT_TTL = 180;